import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import App from "./App";
import appStore from "./store";

import "./index.css";
import "@amzn/awsui-components-react/index.css";

import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
  <Provider store={appStore()}>
    <App />
  </Provider>,

  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
